export const API_BASE_URL = "https://your-api-url.com/";

const PREFIX = "/en/api/v1.0";
const MOBILE_PREFIX = "/en/api/v1/Mobile";

export const GET_PROFILE = `${PREFIX}/User/profile`;
export const ACCOUNT_LOGIN = `${PREFIX}/User/login`;
export const ACCOUNT_LOGIN_V2 = `${PREFIX}/User/login-pos`;
export const SIGN_OUT = `${PREFIX}/User/logout`;
export const VERIFY_ACCOUNT = `${PREFIX}/User/verify-password`;
export const GET_ACCOUNT_POS = `${PREFIX}/Mobile/get-account-web`;
export const FORGOT_PASSWORD = `${PREFIX}/User/password/forgot-by-email`;
export const RESET_PASSWORD = `${PREFIX}/User/password/reset-by-email`;
export const SEARCH_BY_ROLES = `${PREFIX}/User/search-by-roles`;
export const REFRESH_TOKEN_API = `${PREFIX}/TokenManager/refresh-token`;
export const UPDATE_PROFILE = `${PREFIX}/User/profile`;
export const CHANGE_PASS_PROFILE = `${PREFIX}/User/change-pass-profile`;
export const SEARCH_BY_ROLES_REQUEST = `${PREFIX}/User/user-by-roles-request`;
export const GET_ACCOUNT_WORK = `${PREFIX}/Mobile/get-account-work`;
export const GET_ACCOUNT_STORE = `${PREFIX}/Mobile/get-account-store`;

export const SWITCH_ACCOUNT_API = `${PREFIX}/User/switch-account`;
export const MOBILE_GET_ACCOUNT_SWITCH = `${MOBILE_PREFIX}/get-account-v2`;
export const SETTING_PROCESS_PARTNER = `${MOBILE_PREFIX}/setting-process-partner`;
export const SETTING_PROCESS_PARTNER_ALL = `${MOBILE_PREFIX}/setting-process-partner-all`;
export const SETTING_PARTNER_ORDER = `${MOBILE_PREFIX}/setting-partner-order`;
export const SETTING_PARTNER_ORDER_ALL = `${MOBILE_PREFIX}/setting-partner-order-all`;

const SETTING_API = `${PREFIX}/Setting`;
export const SETTING_PAYMENT_GATEWAY = `${SETTING_API}/setting-payment-gateway`;
export const SETTING_STORE_CASH = `${SETTING_API}/setting-cash`;
export const SETTING_STORE_CATEGORY_API = `${SETTING_API}/store-categories`;
export const SETTING_GROUP_CATEGORY_API = `${SETTING_API}/group-categories`;
export const SETTING_RATING_CATEGORY_API = `${SETTING_API}/rating-categories`;
export const GET_SETTING_RATE = `${SETTING_API}/setting-rate`;
export const SETTING_WORD_VIOLATION = `${SETTING_API}/word-violation`;
export const SETTING_MENU_CATEGORY_API = `${SETTING_API}/menu-categories`;
export const SORT_MENU_CATEGORY_API = `${SETTING_MENU_CATEGORY_API}/sort`;
export const SETTING_STORE_UTILITY_API = `${SETTING_API}/store-utility`;
export const SETTING_PRODUCT_ATTRIBUTE = `${SETTING_API}/product-attribute-categories`;
export const SETTING_BANNER = `${SETTING_API}/banner`;
export const SETTING_TERM_CONDITION = `${SETTING_API}/system-setting/term-condition`;
export const SETTING_PRIVACY = `${SETTING_API}/system-setting/privacy`;
export const SETTING_AFFILIATE = `${SETTING_API}/setting-affiliate`;
export const SETTING_ARTIFICIAL_INTELLIGENCE = `${SETTING_API}/setting-artificial-intelligence`;
export const SETTING_MENU_STORE = `${SETTING_API}/menu-store`;
export const SETTING_VOUCHER_PARTNER_LIST = `${SETTING_API}/setting-voucher-partner-list`;
export const SETTING_VOUCHER_PARTNER = `${SETTING_API}/setting-voucher-partner`;
export const EXPORT_VOUCHER_PARTNER_EXCEL = `${SETTING_API}/exel-voucher-partner`;
export const VOUCHER_GEN_CODE_PARTNER = `${SETTING_API}/voucher-gen-code-partner`;
export const APPLY_VOUCHER_STORE = `${SETTING_API}/apply-voucher-store`;

// Affiliate API
export const AFFILIATE_API = `${PREFIX}/Affiliate`;
export const SEARCH_AFFILIATE = `${AFFILIATE_API}/affiliate-search`;
export const UP_SET_AFFILIATE = `${AFFILIATE_API}/affiliate-user`;
export const CHECK_EXISTED_AFFILIATE = `${AFFILIATE_API}/check-affiliate`;
export const DELETE_AFFILIATE = `${AFFILIATE_API}/delete`;
export const GET_PAYMENT_PRICE = `${AFFILIATE_API}/payment-price`;
export const CONFIRM_PAYMENT = `${AFFILIATE_API}/payment`;
export const PAYMENT_HISTORY = `${AFFILIATE_API}/payment-history`;
export const GET_UN_AGENCY = `${AFFILIATE_API}/affiliate-unagency`;

export const PARTNER_API = `${PREFIX}/Partner`;
export const PARNER_SEARCH_GRID = `${PARTNER_API}/search-grid`;
export const PARTNER_CHANGE_STATUS_API = `${PARTNER_API}/change-status`;
export const PARTNER_REGISTER_API = `${PARTNER_API}/register`;
export const PARTNER_REGISTER_VERIFY_API = `${PARTNER_API}/register/verify`;
export const PARTNER_CHANGE_PRESTIGE = `${PARTNER_API}/change-prestige`;
export const LIST_PARTNER_STORE_CRM = `${PARTNER_API}/list-partner-store-crm`;
export const CHANGE_GRAGE_BRAND = `${PARTNER_API}/change-grade-brand`;
export const CHANGE_CATEGORY_PARTNER = `${PARTNER_API}/partner-category`;

const LOCATION_API = `${PREFIX}/Location`;
export const PROVINCE_BY_COUNTRY = `${LOCATION_API}/province-by-country`;
export const DISTRICT_BY_PROVINCE = `${LOCATION_API}/district-by-province`;
export const WARD_BY_DISTRICT = `${LOCATION_API}/ward-by-district`;

const ORDER_API = `${PREFIX}/Order`;
export const GET_ALL_ORDER = `${ORDER_API}/all-order`;
export const SEARCH_ORDER = `${ORDER_API}/search-grid`;
export const SEARCH_ORDER_INVOICE = `${ORDER_API}/search-grid-invoice-v2`;
export const DELETE_ORDER_INVOICE = `${ORDER_API}/delete-order-invoice`;
export const EXPORT_EXEL_ORDER = `${ORDER_API}/export-exel`;
export const SEARCH_ORDER_DETAIL = `${ORDER_API}/detail`;
export const ORDER_CHANGE_STATUS_ALL = `${ORDER_API}/order-item/change-all`;
export const ORDER_ADD_ITEM = `${ORDER_API}/add-item`;
export const ORDER_CONFIRM = `${ORDER_API}/confirm`;
export const ORDER_REJECT = `${ORDER_API}/reject`;
export const ORDER_PAYMENT_CONFIRM = `${ORDER_API}/payment-confirm`;
export const ORDER_PAYMENT_REQUEST = `${ORDER_API}/payment-request`;
export const ORDER_CANCEL_ITEM = `${ORDER_API}/cancel-item`;
export const ORDER_CHANGE_STATUS = `${ORDER_API}/order-item/change-status`;
export const ORDER_UPDATE_EMPLOYEE = `${ORDER_API}/update-order-infor`;
export const ORDER_CREATE_EMPLOYEE = `${ORDER_API}/employee/create`;
export const ORDER_EXTRACT = `${ORDER_API}/extract`;
export const ORDER_GROUP = `${ORDER_API}/group`;
export const ORDER_ITEM_PRINT_STATUS = `${ORDER_API}/order-item/update-order-print`;
export const TABLE_SEARCH_ORDER = `${ORDER_API}/table/search`;
export const TABLE_SEARCH_EMPLOYEE_ORDER = `${ORDER_API}/employee/search`;
export const TABLE_SEARCH_EMPLOYEE_ORDER_V2 = `${ORDER_API}/employee/search-order`;
export const TABLE_SUMMARY_EMPLOYEE_ORDER = `${ORDER_API}/employee/summary-order`;
export const ORDER_ITEM_ADD_EXTERNAL= `${ORDER_API}/order-item/add-external`;
export const ORDER_ITEM_UPDATE_EXTERNAL= `${ORDER_API}/order-item/update-external`;
export const ORDER_CHANGE_CASH = `${ORDER_API}/change-cash`;
export const ORDER_PRE_PAYMENT = `${ORDER_API}/pre-payment`;
export const UPDATE_ORDER_PAID = `${ORDER_API}/update-order-paid`;
export const TABLE_SEARCH_PRODUCT_ORDER = `${ORDER_API}/employee/search-product`;
export const PRODUCT_ITEM_UPDATE_ALL= `${ORDER_API}/product-item/change-all`;
export const SORT_ORDER_ITEMS = `${ORDER_API}/sort-items`;
export const STORE_PRODUCT = `${PREFIX}/Mobile/store/product-by-category`;
export const CHANGE_ORDER_TYPE = `${PREFIX}/Mobile/setting-order`;
export const GET_BANK_QR = `${PREFIX}/Mobile/bank-qr`;
export const GET_STORE_BANK = `${PREFIX}/Mobile/bank`;
export const UPDATE_STORE_BANK = `${PREFIX}/Mobile/setting-bank`;
//XUẤT KHO
export const GET_WAREHOUSE_ORDER = `${ORDER_API}/warehouse/search-order-v2`;
export const GET_WAREHOUSE_ORDER_DETAIL = `${ORDER_API}/warehouse/order-detail`;

export const STORE_API = `${PREFIX}/Store`;
export const STORE_SEARCH_GRID = `${STORE_API}/search-grid`;
export const GET_MY_STORE = `${STORE_API}/my-store`;
export const WORKABLE_STORES = `${STORE_API}/workable-stores`;
export const WORKABLE_STORES_BY_REGION = `${STORE_API}/workable-stores-by-region`;
export const GET_PARTNER_STORE_LIST = `${STORE_API}/partner-store-list`;
export const EXPORT_EXCEL_STORE = `${STORE_API}/export-excel`;

export const STORE_CHANGE_STATE = `${STORE_API}/change-state`;

export const REWARD_POINT_API = `${PREFIX}/RewardPoint`;
export const REWARD_POINT_SEARCH_GRID = `${REWARD_POINT_API}/search-grid`;
export const SAVE_REWARD_POINT = `${REWARD_POINT_API}/save-reward-point`;

export const STORE_WIFI_API = `${PREFIX}/StoreWifi`;
export const STORE_TABLE_API = `${PREFIX}/StoreDinnerTable`;
export const STORE_TABLE_API_CREATE_MULTI = `${STORE_TABLE_API}/add-multi`;

export const PRODUCT_API = `${PREFIX}/Product`;
export const MOBILE_PRODUCT_DETAIL = `${PREFIX}/Mobile/product/Detail`;
export const PRODUCT_SEARCH_GRID = `${PRODUCT_API}/search-v2`;
export const PRODUCT_CHANGE_STATE = `${PRODUCT_API}/change-state`;
export const PRODUCTS_COPY = `${PRODUCT_API}/copy-product`;
export const PRODUCTS_GROUP_CATEGORY = `${PRODUCT_API}/group-category`;
export const PRODUCTS_CHANGE_STATUS = `${PRODUCT_API}/change-status`;
export const PRODUCTS_DISCOUNT = `${PRODUCT_API}/products-discount`;
export const PRODUCT_UPDATE_VARIANT = `${PRODUCT_API}/update-variant`;
export const PRODUCT_WAREHOUSE = `${PRODUCT_API}/warehouse-product`;
export const PRODUCT_WAREHOUSE_V2 = `${PRODUCT_API}/warehouse-product-v2`;
export const PRODUCT_DELETE_MULTI = `${PRODUCT_API}/delete-multi`;

export const PRODUCT_SEARCH_GRID_V2 = `${PRODUCT_API}/search-grid`;
export const PRODUCT_WAREHOUSE_SELECT_LIST = `${PRODUCT_API}/warehouse-menu`;
export const PRODUCT_WAREHOUSE_SEARCH_GRID_V2 = `${PRODUCT_API}/warehouse-menu-v2`;
export const PRODUCT_UPDATE_VARIANT_V2 = `${PRODUCT_API}/update-variant-v2`;
export const SYNC_PRODUCT_PARTNER = `${PRODUCT_API}/sync-product-partner`;
export const APPLY_OTHER_OPTION = `${PRODUCT_API}/apply-other-otpion-product`;
export const APPLY_ADDITION_OPTION = `${PRODUCT_API}/apply-addition-product`;
export const PRODUCTS_GROUP_CATEGORY_V2 = `${PRODUCT_API}/group-category-v2`;

export const SEMI_PRODUCT_API = `${PREFIX}/ProductSemi`;
export const SEMI_PRODUCT_SEARCH_GRID = `${SEMI_PRODUCT_API}/search`;
export const SYNC_SEMI_PRODUCT = `${SEMI_PRODUCT_API}/sync-product-semi`;
export const SYNC_SEMI_PRODUCT_V2 = `${SEMI_PRODUCT_API}/sync-product-semi-v2`;

export const MANAGE_WAREHOUSE_PREFIX = `${PREFIX}/ManageWarehouse`;
export const MATERIAL_CATEGORY = `${MANAGE_WAREHOUSE_PREFIX}/material-categories`;
export const MATERIAL_CATEGORY_COPY = `${MANAGE_WAREHOUSE_PREFIX}/material-categories/copy`;
export const MATERIAL_UNIT = `${MANAGE_WAREHOUSE_PREFIX}/material-unit`;
export const MATERIAL_UNIT_COPY = `${MANAGE_WAREHOUSE_PREFIX}/material-unit/copy`;
export const MATERIAL = `${MANAGE_WAREHOUSE_PREFIX}/material`;
export const MATERIAL_COPY = `${MATERIAL}/copy`;
export const MATERIAL_DETAIL = `${MATERIAL}/detail`;
export const GET_ALL_MATERIAL = `${MATERIAL}/search-grid`;
export const DELETE_MATERIAL_UNIT_EXCHANGE = `${MANAGE_WAREHOUSE_PREFIX}/exchange-unit`;
export const SUPPLIER_URL = `${MANAGE_WAREHOUSE_PREFIX}/supplier`;
export const MATERIAL_CATEGORY_TOOL = `${MANAGE_WAREHOUSE_PREFIX}/material-categories-tool`;

export const MATERIAL_CATEGORY_V2 = `${MANAGE_WAREHOUSE_PREFIX}/material-categories-v2`;
export const MATERIAL_UNIT_V2 = `${MANAGE_WAREHOUSE_PREFIX}/material-unit-v2`;
export const MATERIAL_V2 = `${MANAGE_WAREHOUSE_PREFIX}/material-v2`;
export const MATERIAL_DETAIL_V2 = `${MATERIAL}/detail-v2`;
export const GET_ALL_MATERIAL_V2 = `${MATERIAL}/search-grid-v2`;
export const SYNC_MATERIAL_PARTNER = `${MANAGE_WAREHOUSE_PREFIX}/sync-material-partner`;

export const MANAGE_WAREHOUSE_RECEIPT_PREFIX = `${PREFIX}/WarehouseReceipt`;
export const RECEIPT_SEARCH_GRID = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/search-grid`;
export const GENERATE_RECEIPT = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/warehouse-receipt/generate`;
export const GENERATE_RECEIPT_V2 = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/warehouse-receipt/generate-v2`;
export const CREATE_RECEIPT = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/create-receipt`;
export const UPDATE_RECEIPT = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/update-receipt`;
export const UPDATE_RECEIPT_V2 = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/update-receipt-v2`;
export const UPDATE_RECEIPT_PARTIAL = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/update-receipt-partial`;
export const UPDATE_RECEIPT_MATERIAL = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/update-receipt-material`;
export const DELETE_RECEIPT = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/delete-receipt`;
export const DELETE_RECEIPT_MATERIAL = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/delete-receipt-material`;
export const DETAIL_RECEIPT = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/detail`;
//TRANSFER
export const MANAGE_WAREHOUSE_TRANSFER = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/transfer`;
export const TRANSFER_SEARCH_GRID = `${MANAGE_WAREHOUSE_TRANSFER}/search-grid`;
export const GENERATE_TRANSFER = `${MANAGE_WAREHOUSE_TRANSFER}/generate`;
export const GENERATE_TRANSFER_V2 = `${MANAGE_WAREHOUSE_TRANSFER}/generate-v2`;
export const CREATE_TRANSFER = `${MANAGE_WAREHOUSE_TRANSFER}/create`;
export const UPDATE_TRANSFER = `${MANAGE_WAREHOUSE_TRANSFER}/update`;
export const DELETE_TRANSFER = `${MANAGE_WAREHOUSE_TRANSFER}/delete`;
export const DELETE_TRANSFER_MATERIAL = `${MANAGE_WAREHOUSE_TRANSFER}/delete-transfer-material`;
export const CONFIRM_TRANSFER = `${MANAGE_WAREHOUSE_TRANSFER}/confirm`;
export const CONFIRM_TRANSFER_V2 = `${MANAGE_WAREHOUSE_TRANSFER}/confirm-v2`;
export const DETAIL_TRANSFER = `${MANAGE_WAREHOUSE_TRANSFER}/detail`;
export const UPDATE_TRANSFER_RECEIVED_QUANTITY = `${MANAGE_WAREHOUSE_TRANSFER}/update-received-quantity`;
//WAREHOUSE CHECK
export const MANAGE_WAREHOUSE_CHECK = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/warehouse-check`;
export const CHECK_SEARCH_GRID = `${MANAGE_WAREHOUSE_CHECK}/search-grid`;
export const GENERATE_CHECK = `${MANAGE_WAREHOUSE_CHECK}/generate`;
export const GENERATE_CHECK_V2 = `${MANAGE_WAREHOUSE_CHECK}/generate-v2`;
export const CREATE_CHECK = `${MANAGE_WAREHOUSE_CHECK}/create`;
export const UPDATE_CHECK = `${MANAGE_WAREHOUSE_CHECK}/update`;
export const UPDATE_CHECK_V2 = `${MANAGE_WAREHOUSE_CHECK}/update-v2`;
export const CANCEL_CHECK = `${MANAGE_WAREHOUSE_CHECK}/cancel`;
export const DETAIL_CHECK = `${MANAGE_WAREHOUSE_CHECK}/detail`;

export const WAREHOUSE_UNIT = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/warehouse-unit`;

// XUAT TRA LAI / XUAT HUY / XUAT KHAC
export const WAREHOUSE_EXPORT_PREFIX = `${PREFIX}/WarehouseExport`;
export const WAREHOUSE_EXPORT_SEARCH = `${WAREHOUSE_EXPORT_PREFIX}/search`;
export const WAREHOUSE_EXPORT_RECEIPT = `${WAREHOUSE_EXPORT_PREFIX}/receipt`;
export const WAREHOUSE_EXPORT_GENERATE_RETURN = `${WAREHOUSE_EXPORT_PREFIX}/generate-export-return`;
export const WAREHOUSE_EXPORT_GENERATE = `${WAREHOUSE_EXPORT_PREFIX}/generate-export`;
export const WAREHOUSE_EXPORT_REASONS = `${WAREHOUSE_EXPORT_PREFIX}/get-reason-export`;
export const WAREHOUSE_EXPORT_UPSERT = `${WAREHOUSE_EXPORT_PREFIX}/export`;
export const WAREHOUSE_EXPORT_REASON_UPSERT = `${WAREHOUSE_EXPORT_PREFIX}/reason-export`;
export const ADD_OPTION = `${MOBILE_PREFIX}/store-addition`;

export const CUSTOMER_API = `${PREFIX}/User`;
export const CUSTOMER_SEARCH_GRID = `${CUSTOMER_API}/customer-search-grid`;
export const CUSTOMER_APP_SEARCH_GRID = `${CUSTOMER_API}/customer-app-search-grid`;

export const EMPLOYEE_API = `${PREFIX}/User`;
export const EMPLOYEE_CREATE = `${EMPLOYEE_API}/create-user-v2`;
export const EMPLOYEE_UPDATE = `${EMPLOYEE_API}/update-user-v2`;
export const EMPLOYEE_CHANGE_STATUS = `${EMPLOYEE_API}/change-status`;
export const SEARCH_EMPLOYEE = `${EMPLOYEE_API}/search-employee`;
export const SEARCH_EMPLOYEE_V2 = `${EMPLOYEE_API}/all-employee`;
export const SEARCH_USER = `${EMPLOYEE_API}/search-account`;

const REPORT_API = `${PREFIX}/Report`;
export const REPORT_REVENUE = `${REPORT_API}/report-revenue`;
export const REPORT_TOP_PRODUCT = `${REPORT_API}/report-top-product`;
export const REPORT_STATUS_ORDER = `${REPORT_API}/report-status-order`;
export const REPORT_TOP_EMPLOYEE = `${REPORT_API}/report-top-employee`;
export const REPORT_CHART_REVENUE = `${REPORT_API}/report-chart-revenue`;
export const REPORT_ACCOUNT_REVENUE = `${REPORT_API}/report-account-revenue`;
export const REPORT_ACCOUNT_CHART_REVENUE = `${REPORT_API}/report-account-chart-revenue`;

const VIOLATION_API = `${PREFIX}/ReportViolation`;
export const REPORT_VIOLATION = `${VIOLATION_API}/search-grid`;
export const REPORT_VIOLATION_STATUS = `${VIOLATION_API}/change-status`;
export const HANDLE_REPORT_VIOLATION = `${VIOLATION_API}/handle-report`;

const NOTIFICATION_API = `${PREFIX}/Notification`;
export const SEARCH_NOTIFICATION = `${NOTIFICATION_API}/search`;
export const READ_ALL_NOTIFICATION = `${NOTIFICATION_API}/read-all`;
export const DEL_ALL_NOTIFICATION = `${NOTIFICATION_API}/delete-all`;
export const SAVE_FIREBASE_TOKEN_NOTIFICATION = `${NOTIFICATION_API}/save-firebase-token`;
export const READ_NOTIFICATION = `${NOTIFICATION_API}/mark-read`;
export const SAVE_LABEL_STAR_NOTIFICATION = `${NOTIFICATION_API}/save-label-star`;
export const DEL_MULTI_NOTIFICATION = `${NOTIFICATION_API}/delete-multi`;

export const CUSTOMER_ACCOUNT_DELETE = `${PREFIX}/User/delete`;
export const CUSTOMER_ACCOUNT_CHANGE_STATUS = `${PREFIX}/User/change-status`;
export const CUSTOMER_ACCOUNT_CHANGE_GREEN_SCORE = `${PREFIX}/User/change-green-score`;

export const POST_API = `${PREFIX}/CmsPost`;
export const SEARCH_POST = `${POST_API}/search-grid`;
export const PUBLISH_POST = `${POST_API}/publish`;
export const DELETE_POST = `${POST_API}/delete`;
export const CLONE_POST = `${POST_API}/clone`;
export const COUNT_TOTAL_VIEW_POST = `${PREFIX}/Post/count-total-view`;

export const SHOPPING_CART = `${PREFIX}/ShoppingCart`;
export const SHOPPING_CART_TABLE = `${SHOPPING_CART}/employee/table-cart`;
export const SHOPPING_CART_SORT = `${SHOPPING_CART}/sort-items`;
export const EMPLOYEE_UPSERT_SHOPPING_CART = `${SHOPPING_CART}/employee/up-sert`;
export const EMPLOYEE_UPSERT_EXTERNAL_SHOPPING_CART = `${SHOPPING_CART}/employee/up-sert-external`;
export const UPSERT_SHOPPING_CART = `${SHOPPING_CART}/up-sert`;
export const DELETE_CART = `${SHOPPING_CART}/delete-cart`;
export const CHANGE_QUANTITY = `${SHOPPING_CART}/change-quantity`;
export const CHANGE_CUSTOMER = `${SHOPPING_CART}/change-customer`;
export const CHANGE_TABLE = `${SHOPPING_CART}/change-table`;

export const POST_COMMENT_API = `${PREFIX}/PostComment`;
export const SEARCH_POST_COMMENT = `${POST_COMMENT_API}/root-comments`;
export const ADD_POST_COMMENT = `${POST_COMMENT_API}/add-comment`;
export const UPDATE_POST_COMMENT = `${POST_COMMENT_API}/update-comment`;
export const LIKE_POST_COMMENT = `${POST_COMMENT_API}/like-comment`;
export const DEL_POST_COMMENT = `${POST_COMMENT_API}/delete`;
export const REPLY_POST_COMMENT = `${POST_COMMENT_API}/reply-comment`;
export const GET_REPLY_POST_COMMENT = `${POST_COMMENT_API}/replies-comment`;
export const TOGGLE_HIDE_POST_COMMENT = `${POST_COMMENT_API}/toggle-hide-comment`;


const PREFIX_V2 = "/en/api/v2.0";
// Access history is versioned as /api/v2 (without the .0 used by other v2 APIs).
const ACCESS_HISTORY_API = "/en/api/v2/AccessHistory";
export const ACCESS_HISTORY_SEARCH = `${ACCESS_HISTORY_API}/search`;

const REPORT_API_V2 = `${PREFIX_V2}/Report`;
export const REPORT_REVENUE_V2 = `${REPORT_API_V2}/report-revenue`;
export const REPORT_TIME_V2 = `${REPORT_API_V2}/report-time`;

// SInvoice API;
const PREFIX_INVOICE = `${PREFIX}/StoreInvoice`;
export const GET_STORE_INVOICE = `${PREFIX_INVOICE}/detail-invoice`;
export const UPSET_STORE_INVOICE = `${PREFIX_INVOICE}/up-sert-invoice`;
export const GET_ORDER_INVOICE = `${PREFIX_INVOICE}/order-invoice`;
export const GENERATE_INVOICE = `${PREFIX_INVOICE}/generate-invoice`;
export const UPSET_ORDER_INVOICE = `${PREFIX_INVOICE}/up-sert-order-invoice`;
export const SIGN_ORDER_INVOICE = `${PREFIX_INVOICE}/sign-invoice`;
export const GET_CUSTOMER_INVOICE = `${PREFIX_INVOICE}/customer-invoice`;
export const CHANGE_STATE_SENT_INVOICE = `${PREFIX_INVOICE}/change-invoice-sent`;
export const UPDATE_DRAFT_INVOICE = `${PREFIX_INVOICE}/update-draft-invoice`;
export const UPDATE_DRAFT_EXPORT = `${PREFIX_INVOICE}/update-draft-export`;
export const CHANGE_INVOICE_PARTNER = `${PREFIX_INVOICE}/change-invoice-partner`;

// VInvoice
const PREFIX_SINVOICE = "/services/einvoiceapplication/api/InvoiceAPI";
export const LOGIN_INVOICE = "/auth/login";
export const GET_ALL_TEMPLATE_INVOICE = `${PREFIX_SINVOICE}/InvoiceUtilsWS/getAllInvoiceTemplates`;
export const CREATE_USB_HASH_INVOICE = `${PREFIX_SINVOICE}/InvoiceWS/createInvoiceUsbTokenGetHash`;
export const SIGNATURE_USB_HASH_INVOICE = `${PREFIX_SINVOICE}/InvoiceWS/createInvoiceUsbTokenInsertSignature`;
export const CREATE_HSM_INVOICE = `${PREFIX_SINVOICE}/InvoiceWS/createInvoice`;
export const CREATE_PDF_INVOICE = `${PREFIX_SINVOICE}/InvoiceUtilsWS/getInvoiceRepresentationFile`;
export const CREATE_DRAFT_INVOICE = `${PREFIX_SINVOICE}/InvoiceWS/createOrUpdateInvoiceDraft`;
export const GET_INVOICE_UUID = `${PREFIX_SINVOICE}/InvoiceWS/searchInvoiceByTransactionUuid`;
export const SENT_INVOICE_TAX = `${PREFIX_SINVOICE}/InvoiceWS/sendInvoiceByTransactionUuid`;
export const SIGN_ME_INVOICE = `${PREFIX_INVOICE}/sign-me-invoice`;

//MeInvoice
export const LOGIN_ME_INVOICE = "/webapp/token";
export const GET_TEMPLATE_ME_INVOICE = `${PREFIX_INVOICE}/invoice/templates`;
export const GENERATE_ME_INVOICE = `${PREFIX_INVOICE}/generate-me-invoice`;
export const CREATE_ME_INVOICE = `${PREFIX_INVOICE}/invoice`;
export const CHANGE_STATE_ME_INVOICE = `${PREFIX_INVOICE}/change-state-me-invoice`;
export const DOWNLOAD_ME_INVOICE = `${PREFIX_INVOICE}/invoice/download`;
export const GET_STATUS_INVOICE_PUBLIC = `${PREFIX_INVOICE}/invoice/status`;

// Saas API
const PREFIX_SAAS = `${PREFIX}/Saas`;
export const GET_SUBSCRIPTIONS_LIST = `${PREFIX_SAAS}/search-grid`;
export const GET_SUBSCRIPTIONS_HISTORY = `${PREFIX_SAAS}/search-grid/history`;
export const GET_SUBSCRIPTION_DETAIL = `${PREFIX_SAAS}/subscription`;
export const ACTIVE_SUBSCRIPTION = `${PREFIX_SAAS}/subscription-admin/active`;
export const COPY_SUBSCRIPTION = `${PREFIX_SAAS}/subscription/copy`;
export const TIME_SUBSCRIPTION = `${PREFIX_SAAS}/subscription/time`;
export const TIME_SUBSCRIPTION_V2 = `${PREFIX_SAAS}/subscription/time/v2`;
export const GET_USER_SUBSCRIPTION = `${PREFIX_SAAS}/user-subscription`;
export const GET_PARTNER_SAAS = `${PREFIX_SAAS}/partner`;


// =================Api Credential=================
const PREFIX_CREDENTIAL = `${PREFIX}/ApiCredential`;
export const GET_CREDENTIAL     = `${PREFIX_CREDENTIAL}/get-credential`;
export const UPSERT_CREDENTIAL      = `${PREFIX_CREDENTIAL}/upsert`;

// ================= MISA API =================
const PREFIX_MISA = `${PREFIX}/Misa`;
// GET
export const GET_MISA_ACCOUNT_OBJECTS        = `${PREFIX_MISA}/account-objects`;
export const GET_MISA_INVENTORY_ITEMS        = `${PREFIX_MISA}/inventory-items`;
export const GET_MISA_STOCKS                 = `${PREFIX_MISA}/stocks`;
export const GET_MISA_UNITS                  = `${PREFIX_MISA}/units`;
export const GET_MISA_BANK_ACCOUNTS          = `${PREFIX_MISA}/bank-accounts`;
export const GET_MISA_ORGANIZATION_UNITS     = `${PREFIX_MISA}/organization-units`;
export const GET_MISA_INVENTORY_CATEGORIES   = `${PREFIX_MISA}/inventory-categories`;
// SAVE
export const SAVE_MISA_ACCOUNT_OBJECTS       = `${PREFIX_MISA}/account-objects`;
export const SAVE_MISA_INVENTORY_ITEMS       = `${PREFIX_MISA}/inventory-items`;
export const SAVE_MISA_STOCKS                = `${PREFIX_MISA}/stocks`;
export const SAVE_MISA_UNITS                 = `${PREFIX_MISA}/units`;
export const SAVE_MISA_BANK_ACCOUNTS         = `${PREFIX_MISA}/bank-accounts`;
export const SAVE_MISA_ORGANIZATION_UNITS    = `${PREFIX_MISA}/organization-units`;
export const SAVE_MISA_INVENTORY_CATEGORIES  = `${PREFIX_MISA}/inventory-categories`;
export const MISA_SYNC_DATA                  = `${PREFIX_MISA}/sync`;
export const MISA_RETRY_SYNC_DATA            = `${PREFIX_MISA}/retry`;
// MISA sync log
const PREFIX_SYNC_LOG = `${PREFIX}/ApiSyncLog`;
export const GET_MISA_SYNC_LOGS   = `${PREFIX_SYNC_LOG}/get-all`;
export const GET_MISA_LATEST_SYNC_LOGS   = `${PREFIX_SYNC_LOG}/get-latest-sync`;
export const RETRY_MISA_SYNC_LOG  = `${PREFIX_SYNC_LOG}/retry`;

// Customer Store
const PREFIX_CUSTOMER_STORE = `${PREFIX_V2}/CustomerStore`;
export const GET_ALL_CUSTOMER            = `${PREFIX_CUSTOMER_STORE}/get-all`;
export const GET_CUSTOMER_BY_ID           = `${PREFIX_CUSTOMER_STORE}`;
export const CREATE_CUSTOMER              = `${PREFIX_CUSTOMER_STORE}/create`;
export const UPDATE_CUSTOMER              = `${PREFIX_CUSTOMER_STORE}/update`;
export const DELETE_CUSTOMER              = `${PREFIX_CUSTOMER_STORE}`;
export const SETTING_CUSTOMER_REWARD = `${PREFIX_CUSTOMER_STORE}/setting-customer-reward`;
export const HISTORY_ORDERS               = `${PREFIX_CUSTOMER_STORE}/history-order`;
export const EXPORT_CUSTOMERS_EXCEL       = `${PREFIX_CUSTOMER_STORE}/export-excel`;
export const IMPORT_CUSTOMERS_GOOGLE_SHEET = `${PREFIX_CUSTOMER_STORE}/import-google-sheets`;

// CUSTOMER
export const PREFIX_CUSTOMER = `${PREFIX_V2}/Customer`;
export const GET_ALL_CUSTOMER_V2            = `${PREFIX_CUSTOMER}/get-all`;
export const CREATE_CUSTOMER_V2              = `${PREFIX_CUSTOMER}/create`;
export const UPDATE_CUSTOMER_V2              = `${PREFIX_CUSTOMER}/update`;
export const DELETE_CUSTOMER_V2              = `${PREFIX_CUSTOMER}`;
export const EXPORT_CUSTOMERS_EXCEL_V2       = `${PREFIX_CUSTOMER}/export-excel`;
export const IMPORT_CUSTOMERS_GOOGLE_SHEET_V2 = `${PREFIX_CUSTOMER}/import-google-sheets`;
export const SETTING_CUSTOMER_REWARD_V2 = `${PREFIX_CUSTOMER}/setting-customer-reward`;
export const HISTORY_ORDERS_V2               = `${PREFIX_CUSTOMER}/history-order`;
export const CHANGE_PHONE_CUSTOMER              = `${PREFIX_CUSTOMER}/change-phone`;

//COMMON_CATEGORY
export const PREFIX_COMMON_CATEGORY  = `${PREFIX}/CommonCategory`;
export const CREATE_COMMON_CATEGORY  = `${PREFIX_COMMON_CATEGORY}/create`;
export const UPDATE_COMMON_CATEGORY  = `${PREFIX_COMMON_CATEGORY}/update`;
export const UPDATE_PRIORITY_COMMON_CATEGORY  = `${PREFIX_COMMON_CATEGORY}/update-priority`;
export const GET_ALL_COMMON_CATEGORY = `${PREFIX_COMMON_CATEGORY}/get-all`;
export const DELETE_COMMON_CATEGORY  = `${PREFIX_COMMON_CATEGORY}`;

// ===== Report bổ sung =====
export const REPORT_TYPE_ORDER = `${REPORT_API}/report-type-order`;
export const REPORT_TIME_PAYMENT_V2 = `${REPORT_API_V2}/report-time-payment`;
export const REPORT_REWARD_V2 = `${REPORT_API_V2}/report-reward`;
export const REPORT_CHART_STORE_TOTAL_V2 = `${REPORT_API_V2}/report-chart-store-total`;
export const REPORT_CHART_DISCOUNT_STORE = `${REPORT_API_V2}/report-discount-store`;

// ===== Bán hàng partner =====
export const REPORT_CHART_PARTNER = `${REPORT_API_V2}/report-chart-partner`;
export const SEARCH_ORDER_PARTNER = `${ORDER_API}/warehouse/search-order-partner`;

// ===== Lãi lỗ =====
export const ORDER_WAREHOUSE_REPORT_V2 = `${ORDER_API}/warehouse/order-report-v2`;
const CASHBOOK_API = `${PREFIX}/CashBook`;
export const CASHBOOK_RECEIPT_REPORT = `${CASHBOOK_API}/cashbook-receipt/report`;

// ===== Thu chi partner =====
export const CASHBOOK_RECEIPT_REPORT_PARTNER = `${CASHBOOK_API}/cashbook-receipt/report-partner`;

// ===== Kho hàng =====
export const WAREHOUSE_RECEIPT_REPORT_V2 = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/get-report-v2`;
export const WAREHOUSE_REPORT_BY_TIME = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/warehouse-report/by-time`;

// ===== Kho hàng partner =====
export const WAREHOUSE_REPORT_PARTNER = `${MANAGE_WAREHOUSE_RECEIPT_PREFIX}/get-report-partner`;

// ===== IMPORT EXPORT DỮ LIỆU =====
const PREFIX_IMPORT_EXPORT = `${PREFIX_V2}/ImportExport`;
export const IMPORT_MATERIALS_GOOGLE_SHEET = `${PREFIX_IMPORT_EXPORT}/import-material`;
export const EXPORT_MATERIALS_EXCEL       = `${PREFIX_IMPORT_EXPORT}/export-material`;
export const IMPORT_PRODUCTS_GOOGLE_SHEET = `${PREFIX_IMPORT_EXPORT}/import-product`;
export const EXPORT_PRODUCTS_EXCEL       = `${PREFIX_IMPORT_EXPORT}/export-product`;
export const EXPORT_PROCESSING_PRODUCTS = `${PREFIX_IMPORT_EXPORT}/export-processing-product`;
export const EXPORT_INVENTORY_PRODUCTS = `${PREFIX_IMPORT_EXPORT}/export-inventory-product`;
export const IMPORT_WAREHOUSE_CHECK = `${PREFIX_IMPORT_EXPORT}/import-warehouse-check`;
export const IMPORT_WAREHOUSE_CHECK_EXCEL = `${PREFIX_IMPORT_EXPORT}/import-warehouse-check-excel`;
export const EXPORT_WAREHOUSE_CHECK = `${PREFIX_IMPORT_EXPORT}/export-warehouse-check`;
export const IMPORT_EMPLOYEE = `${PREFIX_IMPORT_EXPORT}/import-employee`;
export const EXPORT_EMPLOYEE_EXCEL       = `${PREFIX_IMPORT_EXPORT}/export-employee`;
export const EXPORT_UNIT_EXCEL           = `${PREFIX_IMPORT_EXPORT}/export-unit`;
export const EXPORT_STOCK_DETAIL_EXCEL   = `${PREFIX_IMPORT_EXPORT}/export-stock-detail`;

// REPORT DETAIL
export const REPORT_DETAIL = `${PREFIX_V2}/ReportDetail`;

export const REPORT_ORDER_DETAIL_SEARCH = `${REPORT_DETAIL}/order/search`;
export const REPORT_ORDER_ITEM_SEARCH = `${REPORT_DETAIL}/order-item/search`;
export const REPORT_PRODUCT_PERFORMANCE_SEARCH = `${REPORT_DETAIL}/product/search`;
export const REPORT_EMPLOYEE_PERFORMANCE_SEARCH = `${REPORT_DETAIL}/employee/search`;
export const REPORT_CUSTOMER_OVERVIEW_SEARCH = `${REPORT_DETAIL}/customer/search`;
export const REPORT_INVOICE_SEARCH = `${REPORT_DETAIL}/invoice/search`;
export const REPORT_TREND_SEARCH = `${REPORT_DETAIL}/trend/search`;
export const REPORT_ORDER_RISK_CONTROL_SEARCH = `${REPORT_DETAIL}/order-risk-control/search`;
export const REPORT_INVENTORY_LOSS_SEARCH = `${REPORT_DETAIL}/inventory-loss/search`;
export const REPORT_INVENTORY_OVERVIEW_SEARCH = `${REPORT_DETAIL}/inventory-overview/search`;
export const REPORT_CASHBOOK_DEBT_SEARCH = `${REPORT_DETAIL}/cashbook-debt/search`;
export const REPORT_PAYMENT_CASH_FLOW_SEARCH = `${REPORT_DETAIL}/payment-cash-flow/search`;
export const REPORT_PROFIT_SEARCH = `${REPORT_DETAIL}/profit-loss/search`;
export const REPORT_SUPPLIER_SEARCH = `${REPORT_DETAIL}/supplier/search`;
export const REPORT_PROMOTION_EFFECT_SEARCH = `${REPORT_DETAIL}/promotion-effect/search`;
export const REPORT_INVENTORY_SUMMARY_SEARCH = `${REPORT_DETAIL}/inventory-summary/search`;
export const SUPPLIER_FILTER_SEARCH = `${REPORT_DETAIL}/supplier-report`;

export const REPORT_DETAIL_EXPORT = `${REPORT_DETAIL}/export`;

// REQUEST ORDER
export const REQUEST_ORDER = `${PREFIX_V2}/RequestOrder`;
export const REQUEST_ORDER_SEARCH_GRID = `${REQUEST_ORDER}/search-grid`;
export const REQUEST_ORDER_DETAIL = `${REQUEST_ORDER}/detail`;
export const REQUEST_ORDER_CREATE = `${REQUEST_ORDER}/create`;
export const REQUEST_ORDER_UPDATE = `${REQUEST_ORDER}/update`;
export const REQUEST_ORDER_UPDATE_PENDING_ITEMS = `${REQUEST_ORDER}/update-pending-items`;
export const REQUEST_ORDER_SUBMIT = `${REQUEST_ORDER}/submit`;
export const REQUEST_ORDER_BRANCH_APPROVE = `${REQUEST_ORDER}/branch/approve`;
export const REQUEST_ORDER_BRANCH_REJECT = `${REQUEST_ORDER}/branch/reject`;
export const REQUEST_ORDER_PURCHASING_APPROVE = `${REQUEST_ORDER}/purchasing/approve`;
export const REQUEST_ORDER_PURCHASING_REJECT = `${REQUEST_ORDER}/purchasing/reject`;
export const REQUEST_ORDER_DELETE = `${REQUEST_ORDER}/delete`;
export const REQUEST_ORDER_CANCEL = `${REQUEST_ORDER}/cancel`;
export const REQUEST_ORDER_TRANSFER_SOURCE_STORES = `${REQUEST_ORDER}/stores`;
export const REQUEST_ORDER_RESYNC_STATUS = `${REQUEST_ORDER}/resync-status`;
export const REQUEST_ORDER_RESOLVE_TRANSFER_ITEMS = `${REQUEST_ORDER}/resolve-transfer-items`;
export const MENU_BADGES = `${REQUEST_ORDER}/menu-badges`;
export const EXPORT_EXCEL_REQUEST_ORDER = `${REQUEST_ORDER}/export-excel`;

// PURCHASE CATEGORY
export const PURCHASE_CATEGORY = `${PREFIX_V2}/PurchaseCategory`;
export const PURCHASE_CATEGORY_ALL = `${PURCHASE_CATEGORY}/all`;
export const PURCHASE_CATEGORY_CREATE = `${PURCHASE_CATEGORY}/create`;
export const PURCHASE_CATEGORY_UPDATE = `${PURCHASE_CATEGORY}/update`;
export const PURCHASE_CATEGORY_DELETE = `${PURCHASE_CATEGORY}/delete`;

// PURCHASE ORDER
export const PURCHASE_ORDER = `${PREFIX_V2}/PurchaseOrder`;
export const PURCHASE_ORDER_SEARCH_GRID = `${PURCHASE_ORDER}/search-grid`;
export const PURCHASE_ORDER_DETAIL = `${PURCHASE_ORDER}/detail`;
export const PURCHASE_ORDER_CREATE = `${PURCHASE_ORDER}/create`;
export const PURCHASE_ORDER_UPDATE = `${PURCHASE_ORDER}/update`;
export const PURCHASE_ORDER_CREATE_FROM_REQUEST_ORDER = `${PURCHASE_ORDER}/create-from-request-order`;
export const PURCHASE_ORDER_MARK_PURCHASING = `${PURCHASE_ORDER}/mark-purchasing`;
export const PURCHASE_ORDER_PAYMENT_STATUS = `${PURCHASE_ORDER}/payment-status`;
export const PURCHASE_ORDER_CLOSE_SHORT = `${PURCHASE_ORDER}/close-short`;
export const PURCHASE_ORDER_DELETE = `${PURCHASE_ORDER}/delete`;
export const PURCHASE_ORDER_RECALCULATE_PROGRESS = `${PURCHASE_ORDER}/recalculate-progress`;
export const PURCHASE_ORDER_ATTACHMENT = `${PURCHASE_ORDER}/attachment`;
export const PURCHASE_ORDER_PREVIEW_PRICES = `${PURCHASE_ORDER}/preview-prices`;
export const PURCHASE_ORDER_CREATE_MULTIPLE_FROM_REQUEST_ORDER = `${PURCHASE_ORDER}/create-multiple-from-request-orders`;
export const PURCHASE_ORDER_PREVIEW_MULTIPLE_PRICES = `${PURCHASE_ORDER}/preview-multiple-from-request-orders`;
export const EXPORT_EXCEL_PURCHASE_ORDER = `${PURCHASE_ORDER}/export-excel`;

// SUPPLIER PRICE
export const SUPPLIER_PRICE = `${PREFIX_V2}/SupplierPrice`;
export const SUPPLIER_PRICE_LIST = `${SUPPLIER_PRICE}/list`;
export const SUPPLIER_PRICE_UPSERT = `${SUPPLIER_PRICE}/upsert`;
export const SUPPLIER_PRICE_ADD = `${SUPPLIER_PRICE}/add`;
export const SUPPLIER_PRICE_HISTORY = `${SUPPLIER_PRICE}/history`;
export const SUPPLIER_PRICE_HISTORY_BY_SUPPLIER = `${SUPPLIER_PRICE}/history-by-supplier`;
export const SUPPLIER_PRICE_DELETE = `${SUPPLIER_PRICE}/delete`;
export const SUPPLIER_PRICE_LOOKUP = `${SUPPLIER_PRICE}/lookup`;
export const SUPPLIER = `${SUPPLIER_PRICE}/suppliers`;
export const SUPPLIER_EXPORT = `${SUPPLIER}/export`;

const PURCHASE_REPORT_API_V2 = `${PREFIX_V2}/PurchaseReport`;
export const PURCHASE_SUMMARY_CARDS = `${PURCHASE_REPORT_API_V2}/summary-cards`;
export const PURCHASE_REQUEST_ORDER_STATUS_DISTRIBUTION = `${PURCHASE_REPORT_API_V2}/request-order-status-distribution`;
export const PURCHASE_PURCHASE_ORDER_STATUS_DISTRIBUTION = `${PURCHASE_REPORT_API_V2}/purchase-order-status-distribution`;
export const PURCHASE_TOP_BRANCH = `${PURCHASE_REPORT_API_V2}/top-branches`;
export const PURCHASE_TOP_REQUEST_ITEMS = `${PURCHASE_REPORT_API_V2}/top-request-items`;
export const PURCHASE_TOP_SUPPLIERS = `${PURCHASE_REPORT_API_V2}/top-suppliers`;
export const PURCHASE_PAYMENT_SUMMARY = `${PURCHASE_REPORT_API_V2}/payment-summary`;
export const PURCHASE_SUPPLIER_DEBT_SUMMARY = `${PURCHASE_REPORT_API_V2}/supplier-debt-summary`;
export const PURCHASE_SUPPLIER_DEBT_LIST = `${PURCHASE_REPORT_API_V2}/supplier-debt-list`;
export const PURCHASE_EXPORT_EXCEL = `${PURCHASE_REPORT_API_V2}/export-excel`;

// EMAIL - gửi mail nhà cung cấp
export const EMAIL = `${PREFIX_V2}/Email`;
export const EMAIL_SEND_PURCHASE_ORDER = `${EMAIL}/send-purchase-order`;
export const EMAIL_RESEND = `${EMAIL}/resend`;
export const EMAIL_HISTORY = `${EMAIL}/history`;
export const EMAIL_STATUS_SUMMARY = `${EMAIL}/status-summary`;
export const EMAIL_DETAIL = `${EMAIL}/detail`;
export const EMAIL_CAMPAIGN_CREATE = `${EMAIL}/campaign/create`;
export const EMAIL_CAMPAIGN_UPDATE = `${EMAIL}/campaign/update`;
export const EMAIL_VERIFY_CREDENTIAL = `${EMAIL}/verify-credential`;

// EMAIL SENDER - cấu hình người gửi Brevo
export const EMAIL_SENDER = `${PREFIX_V2}/EmailSender`;
export const EMAIL_SENDER_SEARCH_GRID = `${EMAIL_SENDER}/list`;
export const EMAIL_SENDER_CREATE = `${EMAIL_SENDER}/create`;
export const EMAIL_SENDER_UPDATE = `${EMAIL_SENDER}/update`;
export const EMAIL_SENDER_DELETE = `${EMAIL_SENDER}/delete`;
 
// EMAIL TEMPLATE - mẫu email
export const EMAIL_TEMPLATE = `${PREFIX_V2}/EmailTemplate`;
export const EMAIL_TEMPLATE_SEARCH_GRID = `${EMAIL_TEMPLATE}/list`;
export const EMAIL_TEMPLATE_DETAIL = `${EMAIL_TEMPLATE}/detail`;
export const EMAIL_TEMPLATE_CREATE = `${EMAIL_TEMPLATE}/create`;
export const EMAIL_TEMPLATE_UPDATE = `${EMAIL_TEMPLATE}/update`;
export const EMAIL_TEMPLATE_DELETE = `${EMAIL_TEMPLATE}/delete`;

//PARTNER OPTION
export const ADDITION_OPTION = `${MOBILE_PREFIX}/partner-addition`;
export const OTHER_OPTION = `${PARTNER_API}/partner-other-option`;

//GET UNIT BY PARTNER
export const PARTNER_UNIT = `${PARTNER_API}/partner-unit`;

//SWITCH WORKSPACE
export const PERMISSION_API = `${PREFIX_V2}/Permission`;
export const MY_PERMISSION_API = `${PREFIX_V2}/Permission/me`;
export const SWITCH_WORKSPACE = `${PERMISSION_API}/switch-workspace`;
export const SETTING_PRINTER_PARTNER = `${MOBILE_PREFIX}/setting-printer-partner`;
export const SETTING_PRINTER_PARTNER_ALL = `${MOBILE_PREFIX}/setting-printer-partner-all`;
export const SETTING_PRODUCT_PARTNER = `${MOBILE_PREFIX}/setting-product-partner`;
export const STORE_VAT = `${MOBILE_PREFIX}/store-vat`;
export const STORE_VOUCHER_REWARD = `${MOBILE_PREFIX}/store-voucher-reward`;
export const STORE_LIST_PARTNER_V2 = `${STORE_API}/search-grid-v2`; 

export const PROVINCE_BY_COUNTRY_V2 = `${LOCATION_API}/province-by-country-v2`;
export const WARD_BY_PROVINCE = `${LOCATION_API}/ward-by-province`;
export const GET_CURRENCY_LIST = `${SETTING_API}/currency-list`;

export const STORE_UPSERT_V2 = `${STORE_API}/v2`;

const INVENTORY_TRANSACTION_API = `${PREFIX_V2}/InventoryTransaction`;
export const INVENTORY_TRANSACTION_HISTORY = `${INVENTORY_TRANSACTION_API}/history`;
export const INVENTORY_TRANSACTION_SUMMARY = `${INVENTORY_TRANSACTION_API}/summary`;

export const PRICELIST_API = `${PREFIX_V2}/PriceList`;
export const PRICELIST_GET_ALL = `${PRICELIST_API}/all`;
export const PRICELIST_CREATE = `${PRICELIST_API}/create`;
export const PRICELIST_UPDATE = `${PRICELIST_API}/update`;
export const PRICELIST_CHANGE_STATUS = `${PRICELIST_API}/change-status`;
export const PRICELIST_DELETE = `${PRICELIST_API}/delete`;
export const PRICELIST_STORES = `${PRICELIST_API}/stores`;
export const PRICELIST_GET_STORE_PRICELIST = `${PRICELIST_API}/store-price-list`;
export const PRICELIST_APPLY_STORES = `${PRICELIST_API}/apply-stores`;
export const PRICELIST_STORE = `${PRICELIST_API}/store`;
export const PRICELIST_PRODUCTS = `${PRICELIST_API}/products`;
export const PRICELIST_PRODUCT_DETAIL = `${PRICELIST_API}/product-detail`;
export const PRICELIST_ITEMS = `${PRICELIST_API}/items`;
export const PRICELIST_RESET_ITEMS = `${PRICELIST_ITEMS}/reset`;
export const PRICELIST_BULK_DISCOUNT = `${PRICELIST_API}/bulk-discount`;
export const PRICELIST_BULK_STATUS = `${PRICELIST_API}/bulk-status`;
export const PRICELIST_HISTORY = `${PRICELIST_API}/history`;
